import type { As } from '@chakra-ui/react'
import { Product } from 'BrokerTsLib/src/enums'
import { Link } from 'react-router-dom'

const businesskaUrl = import.meta.env.VITE_BUSINESSKA_URL

export interface IAvailableApps {
  appId: 'carkulka' | 'chaloupka' | 'sme' | 'cestovko' | 'carkulka-extra'
}

export interface IAvailableAppsProps {
  id: IAvailableApps['appId']
  name: string
  product: Product | null
  linkProps: {
    as: As
    to?: string
    href?: string
  }
}

export const useGetAvailableApps = () => {

  const apps: Array<IAvailableAppsProps> = [
    {
      id: 'carkulka',
      name: 'Carkulka',
      product: Product.VehicleInsurance,
      linkProps: {
        as: Link,
        to: '/carkulka'
      }
    },
    {
      id: 'carkulka-extra',
      name: 'Doplňkové připojištění',
      product: Product.VehicleInsurance,
      linkProps: {
        as: Link,
        to: '/extra'
      }
    },
    {
      id: 'chaloupka',
      name: 'Chaloupka',
      product: Product.PropertyInsurance,
      linkProps: {
        as: Link,
        to: '/chaloupka'
      }
    },
    {
      id: 'cestovko',
      name: 'Cestovní pojištění',
      product: Product.TravelInsurance,
      linkProps: {
        as: Link,
        to: '/cestovko'
      }
    },
    {
      id: 'sme',
      name: 'Businesska',
      product: null,
      linkProps: {
        as: 'a',
        href: businesskaUrl
      }
    }
  ]

  return apps
}